import { z } from "zod";
import { ActorKind } from "../enums.js";
export const EntityType = z.enum(["project", "step", "task", "source", "brief", "report"]);
export const EventType = z.enum([
    "created",
    "updated",
    "status_changed",
    "due_changed",
    "assigned",
    "completed",
    "dropped",
    "reordered",
    "brief_regenerated",
    "health_changed",
    "batch",
    "undone",
    "note",
]);
export const RefKind = z.enum(["chat_message", "source", "report", "agent_run", "api"]);
export const EntityRef = z.object({
    type: EntityType,
    id: z.string().uuid(),
    project_id: z.string().uuid().nullable(),
});
export const Event = z.object({
    id: z.string().uuid(),
    project_id: z.string().uuid().nullable(),
    entity_type: EntityType,
    entity_id: z.string().uuid(),
    type: EventType,
    actor_kind: ActorKind,
    actor_user: z.object({ id: z.string().uuid(), name: z.string() }).nullable(),
    actor_token_name: z.string().nullable(),
    ref_kind: RefKind.nullable(),
    ref_id: z.string().uuid().nullable(),
    data: z.record(z.string(), z.unknown()),
    summary: z.string(),
    undoable: z.boolean(),
    undone_by: z.string().uuid().nullable(),
    created_at: z.string(),
});
export const UndoResult = z.object({
    affected: z.array(EntityRef),
    redo_event_id: z.string().uuid(),
});
//# sourceMappingURL=event.js.map